/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    //"aws_cognito_identity_pool_id": "us-west-2:3f402fb1-ffda-4f38-a23c-59a547193445",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_DaepwVFo2",
    "aws_user_pools_web_client_id": "32m7k9ajsj9kr7f5skku2jgj73",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "divscoreAPI",
            "endpoint": "https://mp3au5pgdd.execute-api.us-west-2.amazonaws.com/dev",
            "region": "us-west-2"
        }
    ]
};



export default awsmobile;